import React from "react";
import { Button, Form, Input, Row, Select } from "antd";
import { func } from "prop-types";
import { initialFilters } from "../../utils/utils";
import moment from "moment";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/zh_CN";
import { wrap } from "lodash";
import { width } from "dom7";

const { Option } = Select;
const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
const InspectionFilter = ({ onChange, oldForm }) => {

  const onFinish = (form) => {
    const values = {
      ...form,
      'endDate': form['endDate']?.format('DD/MM/YYYY'),
      'createdAt': form['createdAt']?.format('DD/MM/YYYY'),
      'startDate': form['startDate']?.format('DD/MM/YYYY'),
    };
    onChange(values)
  };

  const convertValues = () => {
		console.log("query: ", oldForm)
    const values = {
      ...form,
      'createdAt': oldForm['createdAt'] ?  moment(oldForm['createdAt'], 'DD/MM/YYYY'): undefined, 
      'creatorFullName': oldForm['creatorFullName'], 
      'currentStatus': oldForm['currentStatus'], 
      'endDate': oldForm['endDate'] ? moment(oldForm['endDate'], 'DD/MM/YYYY'): undefined,
      'inspectionType': oldForm['inspectionType'], 
      'inspectorFullName': oldForm['inspectorFullName'], 
      'inspectorInternalCode': oldForm['inspectorInternalCode'], 
      'startDate': oldForm['startDate'] ?  moment(oldForm['startDate'], 'DD/MM/YYYY'): undefined,
      'upCode': oldForm['upCode']
    };

    return values
  }

  const styleItem = {
     width: "24%", padding:"5px" 
  }
  const [form] = Form.useForm();
  form.setFieldsValue(convertValues())
  return (
    <div>
      <Form
        form={form}
        initialValues={initialFilters}
        onFinish={onFinish}
        locale={locale}
        style={{ display: "flex", flexDirection: 'column', alignItems: 'flex-end' }}
      >
        <div
          style={{ display: "flex", WebkitFlexWrap: "wrap", flexWrap: "wrap" }}
        >
          <Form.Item
            label="Supervisor"
            name="creatorFullName"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
           
          >
            <Input allowClear placeholder="Nombre de Supervisor" />
          </Form.Item>
          <Form.Item
					label="Inspector"
					name="inspectorFullName"
          style={styleItem}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
					
				>
					<Input placeholder="Nombre de inspector" allowClear />
				</Form.Item>
          <Form.Item
            label="Codigo de inspector "
            name="inspectorInternalCode"

            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            dependencies={['inspectorInternalCode']}
            rules={[
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.resolve();
                  }
              
                  return Promise.resolve();
                },
              })
            ]}
          >
            <Input allowClear placeholder="Codigo interno" />
          </Form.Item>
          <Form.Item
            label="Tipo de Inspección"
            name="inspectionType"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select placeholder="Tipo de monitoreo">
              <Option value="TRAMPA">Trampa</Option>
              <Option value="CAMPO">Campo</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="UP"
            name="upCode"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input allowClear placeholder="Código de UP" />
          </Form.Item>
          <Form.Item
            label="Estado"
            name="currentStatus"
            style={{ width: "24%" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select placeholder="Estado">
              <Option value="NUEVA">Nueva</Option>
              <Option value="RECHAZADA">Rechazada</Option>
              <Option value="ACEPTADA">Aceptada</Option>
              <Option value="FINALIZADA">Finalizada</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="F. de alta"
            name="createdAt"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <DatePicker
              placeholder="Alta"
              format={dateFormatList}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label="F. de inicio"
            name="startDate"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <DatePicker
              placeholder="Inicio"
              format={dateFormatList}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label="F. de fin"
            name="endDate"
            style={styleItem}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <DatePicker
              placeholder="Fin"
              format={dateFormatList}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </div>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={false}
          >
            Buscar
          </Button>
          <Button
            type="link"
            htmlType="submit"
            loading={false}
            onClick={() => form.resetFields()}
          >
            Limpiar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

InspectionFilter.propTypes = {
  onChange: func.isRequired,
};

export default InspectionFilter;
